

































































import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Doughnut from "@/charts/Doughnut.vue";
import jsonURLTotal from "@/shared/UrlsTotal";
import GraphData, {
  DataSet,
  ChartOptions,
  MyOptions,
} from "@/charts/graphData";
import moment from "moment/moment";
import ChartsCommon from "./chartsMixin";

@Component({
  components: {
    Doughnut,
  },
})
export default class EquipementsPrestaGraph extends mixins(ChartsCommon) {
  public dataGetted = false;
  public labels: Array<string> = [];
  public dataVente: Array<number> = [];
  public dataPresta: Array<number> = [];
  public optionsVente: ChartOptions = new ChartOptions();
  public optionsPresta: ChartOptions = new ChartOptions();
  public config: any;
  public titre = "";

  @Prop() public equipements!: boolean;
  @Prop() public myOptions!: MyOptions;

  @Watch("myOptions", { immediate: false, deep: true })
  public onPeriodeChanged(value: any, oldValue: any) {
    this.init();
  }

  public mounted() {
    // moment.locale("fr");
  }

  public getMyId(type: string) {
    const ti = this.equipements ? "E" : "P";
    return type + ti;
  }

  public init() {
    this.dataGetted = false;
    this.config = {
      site: this.myOptions.site,
      date: moment(this.myOptions.date).format("YYYY-MM-DD"),
      colors: this.colors,
    };
    this.updateWs();
    this.orderConfig();
    this.$store
      .dispatch("home/getGraphDataTotal", this.config)
      .then((data: any) => {
        this.orderData(data);
        this.setOptions();
      });
  }
  /**
   * mise a jour du titre du graphique (date)
   */
  private orderConfig(): any {
    let graphTitle = "";
    graphTitle = this.dateOrdering(this.myOptions.periode, this.myOptions.date);
    this.titre = graphTitle;
  }
  /**
   * mise a jour du web service en fonction de la periode
   */
  private updateWs() {
    if (this.equipements) {
      switch (this.myOptions.periode) {
        case "J":
          this.config.WS = jsonURLTotal.PRESTA_CA_EQUIPEMENT_JOUR;
          break;
        case "MOIS":
          this.config.WS = jsonURLTotal.PRESTA_CA_EQUIPEMENT_MOIS;
          break;
        case "ANNEE":
          this.config.WS = jsonURLTotal.PRESTA_CA_EQUIPEMENT_ANNEE;
          break;
      }
    } else {
      switch (this.myOptions.periode) {
        case "J":
          this.config.WS = jsonURLTotal.PRESTA_MOYPAI_JOUR;
          break;
        case "MOIS":
          this.config.WS = jsonURLTotal.PRESTA_MOYPAI_MOIS;
          break;
        case "ANNEE":
          this.config.WS = jsonURLTotal.PRESTA_MOYPAI_ANNEE;
          break;
      }
    }
  }

  /**
   * methode permettant de mettre à jour les options du graphique
   */
  private setOptions() {
    this.optionsVente.setTitleTxt(this.$t("VENTE").toString());
    this.optionsPresta.setTitleTxt(this.$t("PRESTA").toString());
    this.optionsVente.makeMeADoughnut();
    this.optionsPresta.makeMeADoughnut();
    // console.log(this.optionsPresta);
  }
  /**
   * mise en forme des données
   */
  private orderData(lignes: any) {
    // 1: vente, 0 : presta
    let labels = [];
    this.labels = [];
    this.dataVente = [];
    this.dataPresta = [];
    labels = Object.keys(lignes);
    labels.forEach((label: string) => {
      if (label !== "") {
        this.labels.push(label);
        this.dataVente.push(lignes[label][1]);
        this.dataPresta.push(lignes[label][0]);
      }
    });
    this.dataGetted = true;
  }
}
